export default "__VITE_ASSET__BU1dMd4f__"